import React from 'react';

import {IconComponent} from "../../reusable/simpleComponents";
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {LayoutState} from "../../../store/layouts/types";
import {triggerHelpTable} from "../../../store/layouts/actions";


const HelpUIComponent = () => {
    const dispatch = useDispatch();
    const { helpTableOpened } = useSelector<ApplicationState, LayoutState>(state => state.layouts);


    const handler = () => {
        dispatch(triggerHelpTable(!helpTableOpened));
    };

    return (
        <IconComponent classValue={'help-icon icon'}
                       handler={handler}
                       title="Help/About"
        />
    )
}

export default HelpUIComponent